<button
  mat-icon-button
  [matTooltip]="'Duplicate'"
  [intercomTarget]="'toolbar-context-menu-duplicate'"
  (click)="duplicateClick.emit()"
>
  <fa-icon class="fs-08" [icon]="['fal', 'copy']"></fa-icon>
</button>
